import AssessmentResult from "./AssessmentResult";
import Mark from "./Mark";
import Paper from "./Paper";

export {
	AssessmentResult,
	Mark,
	Paper,
};
